import { uri } from '../../api-endpoint';
import {
  IAnnotationFromAPISuccessResponse,
  ICreateAnnotationAPIValidationError
} from '../../type-conversion/annotation/from-api-repsonse';
import { CreateAnnotationAPIRequestBody } from '../../type-conversion/annotation/to-api-request-body';
import { createTemplateFn } from '../common';

export const createProjectImageAnnotation = (token: string) => (
  projectId: number,
  imageId: number
) =>
  createTemplateFn(
    token,
    uri.projectImageAnnotationList(projectId, imageId),
    CreateAnnotationAPIRequestBody,
    IAnnotationFromAPISuccessResponse,
    ICreateAnnotationAPIValidationError
  );
